module.exports = __webpack_public_path__ + "media/site/images/voicetalents-slider/voicetalents_screens-02-a8ec4445c731514e5feaf091f77c8602.jpg";